<template>
	<div ref="scrollContainer" id="page-po" v-loading.fullscreen.lock="loading" >
    <el-row>
      <el-col style="padding-left:10px;">
        <SalesOrdersView @close="close" @editSalesOrder="openSalesOrderEditor" @duplicate="handleDuplication"></SalesOrdersView>
      </el-col>
    </el-row>
    <CreateSalesOrderDialog :dialogVisible.sync="soDialogVisible" @close="closeSODialog" :editSelectedSalesOrder="editSelectedSalesOrder"></CreateSalesOrderDialog>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import CreateSalesOrderDialog from '@/components/salesOrder/create-sales-order-dialog.vue'
import SalesOrdersView from './components/sales-order-view'

export default {
  data() {
    return {
      soDialogVisible : false,
			editSelectedSalesOrder : null
    };
  },components: {
    CreateSalesOrderDialog,
		SalesOrdersView
  },
  watch : {
		salesOrderId(salesOrderId, previousSalesOrderId) {
			if (salesOrderId !== previousSalesOrderId) {
				this.selectSalesOrder({salesOrderId, index:null});
			}
		}
  },
	methods: {
    handleDuplication (so) {
			return this.duplicate(so)
				.then(() => this.openSODialog())
				.catch(() => null);
    },
		openSalesOrderEditor(){
			this.editSelectedSalesOrder = this.selectedSalesOrder;
			this.openSODialog();
		},
		close(){
			var index='/sales-orders';
			this.$router.push(index);
		},
		openSODialog(){
			this.soDialogVisible=true;
		},
		closeSODialog(){
			this.soDialogVisible=false;
			this.editSelectedSalesOrder=null;
		},
		...mapActions('salesOrders', [ 'selectSalesOrder']),
    ...mapActions('salesOrderEditor', [ 'duplicate']),
	},
	computed: {
		salesOrderId(){
			return this.$route.params.salesOrderId;
		},
		...mapState('salesOrders',['loading','selectedSalesOrder'])
	},
  mounted(){

  },
	created(){

		this.selectSalesOrder({salesOrderId : this.salesOrderId, index:null});
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
